<template minapp='mpx' xlang='wxml'>
  <view
  class='custom-class transition'
  wx:if="{{inited}}"
  wx:class="{{classname}}"
  wx:style="{{displayStyle}}"
  bindtap='onClick'
  >
    <slot ></slot>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { nextFrame } from '../common/script/raf'
  import { isFunction } from '@didi/es-mpx-shared'
  import { getIndex, upDateIndex } from '../common/script/zIndex'

  createComponent({
    props: {
      show: {
        type: Boolean,
        value: false
      },
      name: {
        type: String,
        value: 'fade'
      },
      customStyle: null
    },

    data: {
      inited: false,
      display: false,
      status: ''
    },

    watch: {
      show: {
        immediate: true,
        handler(val, old) {
          if (val === old) {
            return
          }
          this.run(val)
        }
      }
    },

    computed: {
      classname() {
        return {
          [this.name + '-' + this.status]: true
        }
      },

      displayStyle() {
        return {
          // display: this.display ? '' : 'none',
          zIndex: getIndex(),
          ...this.customStyle
        }
      }
    },

    methods: {
      onClick() {
        this.$trigger('click')
      },

      setStatus(status) {
        if (isFunction(status)) {
          return status.call(this)
        }
        this.status = status

        return status
      },

      setActive() {
        this.inited = true
        this.display = true
        // upDateIndex()
      },

      setCancel() {
        setTimeout(() => {
          if (!this.show && this.display) {
            // this.display = false
            this.inited = false
            this.$trigger('leave')
          }
        }, 300)
      },

      enter() {
        return ['enter', this.setActive, 'enter-to']
      },

      leave() {
        return ['leave', this.setCancel, 'leave-to']
      },

      run(value) {
        return nextFrame.mapInFrames(value ? this.enter() : this.leave(), status =>
          this.setStatus(status)
        )
      }
    }
  })
</script>

<style lang='stylus' src='./style.styl'></style>
<script  type='application/json' lang='json'>
{
 "component": true
}
</script>

